import { Outlet } from "react-router-dom";

const DailyCheckinPage = () => <Outlet />;
export default DailyCheckinPage;